import { render, staticRenderFns } from "./TemplateSelector.vue?vue&type=template&id=3e4647e1&"
import script from "./TemplateSelector.vue?vue&type=script&lang=ts&"
export * from "./TemplateSelector.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateSelector.vue?vue&type=style&index=0&id=3e4647e1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
